import requester from '@/services/requester'
import env from '@/.env.js'

const BACKEND_API_V1_URL = env.endpoint_backend

export default {
    requestInformation (parameters) {
        return requester.post(`${BACKEND_API_V1_URL}/emails/requestinformation`, parameters)
    },
}